/*
  Tablya : rail de collections (sections/tablya-collections.liquid).
  - Flèches précédent / suivant : avancent d'une carte (largeur + écart), désactivées aux extrémités,
    masquées quand tout tient à l'écran.
  - Éditeur de thème : sélectionner un bloc fait défiler le rail jusqu'à sa carte.
  - « Réduire les animations » : défilement instantané.
  Élément personnalisé : il se réinitialise tout seul quand l'éditeur recharge la section.
*/
(function () {
  'use strict';

  if (!window.customElements || customElements.get('tablya-rail')) return;

  var reduit = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function comportement() {
    return reduit && reduit.matches ? 'auto' : 'smooth';
  }

  class TablyaRail extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-tb-rail]');
      this.fleches = this.querySelector('[data-tb-fleches]');
      if (!this.rail || !this.fleches) return;

      this.boutons = Array.prototype.slice.call(this.fleches.querySelectorAll('[data-tb-direction]'));
      this.enAttente = false;

      this.surClic = this.surClic.bind(this);
      this.planifier = this.planifier.bind(this);
      this.surBloc = this.surBloc.bind(this);

      this.boutons.forEach(
        function (bouton) {
          bouton.addEventListener('click', this.surClic);
        }.bind(this)
      );
      this.rail.addEventListener('scroll', this.planifier, { passive: true });

      if ('ResizeObserver' in window) {
        this.observateur = new ResizeObserver(this.planifier);
        this.observateur.observe(this.rail);
      } else {
        window.addEventListener('resize', this.planifier);
      }

      document.addEventListener('shopify:block:select', this.surBloc);
      this.majEtat();
    }

    disconnectedCallback() {
      if (this.rail) this.rail.removeEventListener('scroll', this.planifier);
      if (this.observateur) this.observateur.disconnect();
      window.removeEventListener('resize', this.planifier);
      document.removeEventListener('shopify:block:select', this.surBloc);
    }

    pas() {
      var carte = this.rail.firstElementChild;
      if (!carte) return this.rail.clientWidth;
      var style = window.getComputedStyle(this.rail);
      var ecart = parseFloat(style.columnGap || style.gap) || 0;
      return carte.getBoundingClientRect().width + ecart;
    }

    surClic(event) {
      var bouton = event.currentTarget;
      if (bouton.getAttribute('aria-disabled') === 'true') return;
      var sens = Number(bouton.getAttribute('data-tb-direction')) || 1;
      this.rail.scrollBy({ left: sens * this.pas(), behavior: comportement() });
    }

    planifier() {
      if (this.enAttente) return;
      this.enAttente = true;
      window.requestAnimationFrame(
        function () {
          this.enAttente = false;
          this.majEtat();
        }.bind(this)
      );
    }

    majEtat() {
      var rail = this.rail;
      var max = rail.scrollWidth - rail.clientWidth;
      var deborde = max > 2;
      this.fleches.hidden = !deborde;
      if (!deborde) return;

      // scrollLeft peut être négatif dans une page en écriture de droite à gauche
      var position = Math.abs(rail.scrollLeft);
      this.boutons.forEach(function (bouton) {
        var sens = Number(bouton.getAttribute('data-tb-direction'));
        var bloque = sens < 0 ? position <= 2 : position >= max - 2;
        bouton.setAttribute('aria-disabled', bloque ? 'true' : 'false');
      });
    }

    surBloc(event) {
      if (!this.contains(event.target)) return;
      var item = event.target.closest('li') || event.target;
      var rail = this.rail;
      var marge = parseFloat(window.getComputedStyle(rail).paddingLeft) || 0;
      var decalage =
        item.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft - marge;
      rail.scrollTo({ left: Math.max(0, decalage), behavior: comportement() });
    }
  }

  customElements.define('tablya-rail', TablyaRail);
})();
